// AI-CONTEXT: See docs/features/deep-analysis-period.md
//
// The top of one value axis shared by two compared charts. Left to itself each
// half scales to its own data (2.5 next to 4), so equally tall bars mean
// different numbers (testronde 2026-10-28, B2). Undefined when there is
// nothing positive to scale — the chart then keeps its own axis.

/**
 * @param {Array<*>} values - All plotted values of both halves
 * @returns {number|undefined} The highest value rounded up to a whole number
 */
const sharedAxisMax = (values) => {
    const numbers = (values || []).filter((v) => typeof v === 'number' && Number.isFinite(v))
    if (numbers.length === 0) return undefined
    const max = Math.max(...numbers)
    return max > 0 ? Math.ceil(max) : undefined
}

/**
 * Whole-number ticks for a shared axis. Recharts' own split of [0, 5] came out
 * as 0, 2, 5; whole steps read better. A tall axis is left to the chart.
 * @param {number|undefined} max - Top of the axis (from sharedAxisMax)
 * @returns {Array<number>|undefined}
 */
export const axisTicks = (max) => (max && max <= 10 ? Array.from({ length: max + 1 }, (_, i) => i) : undefined)

export default sharedAxisMax
